import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { CTAButton } from './ui/CTAButton';
export function CountdownSection() {
  const {
    minutes,
    seconds,
    isUrgent
  } = useCountdown(15);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <section className="py-8 md:py-12 px-4 bg-brand-dark border-y-4 border-brand-orange" data-id="element-41">
      <div className="max-w-4xl mx-auto text-center" data-id="element-42">
        <h2 className="text-2xl md:text-4xl font-black text-white mb-4 md:mb-6" data-id="element-43">
          ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
        </h2>

        <div className={`flex justify-center gap-4 md:gap-8 mb-6 md:mb-8 ${isUrgent ? 'animate-pulse' : ''}`} data-id="element-44">
          <div className="flex flex-col items-center" data-id="element-45">
            <div className="bg-white/10 text-white text-5xl md:text-7xl font-black p-4 md:p-6 rounded-xl shadow-inner border border-white/10 min-w-[80px] md:min-w-[120px]" data-id="element-46">
              {formatTime(minutes)}
            </div>
            <span className="text-gray-400 font-bold mt-2 uppercase" data-id="element-47">min</span>
          </div>
          <div className="text-5xl md:text-7xl font-black text-white self-start mt-2 md:mt-4" data-id="element-48">
            :
          </div>
          <div className="flex flex-col items-center" data-id="element-49">
            <div className={`${isUrgent ? 'bg-red-600' : 'bg-brand-orange'} text-white text-5xl md:text-7xl font-black p-4 md:p-6 rounded-xl shadow-inner min-w-[80px] md:min-w-[120px]`} data-id="element-50">
              {formatTime(seconds)}
            </div>
            <span className="text-gray-400 font-bold mt-2 uppercase" data-id="element-51">seg</span>
          </div>
        </div>

        <p className="text-xl md:text-2xl font-bold text-red-400 mb-5 md:mb-8" data-id="element-52">
          Después sube $10.000 ARS y no vuelve a bajar.
        </p>

        <div className="max-w-2xl mx-auto bg-white/5 p-4 md:p-6 rounded-2xl border border-white/10 mb-5 md:mb-8" data-id="element-53">
          <div className="flex justify-between text-sm font-bold text-gray-300 mb-2" data-id="element-54">
            <span data-id="element-55">🔴 Cupos al precio de lanzamiento</span>
            <span data-id="element-56">Quedan pocos</span>
          </div>
          <div className="w-full bg-white/10 rounded-full h-4 mb-2 overflow-hidden" data-id="element-57">
            <div className="bg-red-600 h-4 rounded-full" style={{
            width: '68%'
          }} data-id="element-58"></div>
          </div>
          <div className="text-right text-sm font-bold text-red-400" data-id="element-59">
            68% de los cupos tomados
          </div>
        </div>

        <div className="max-w-xl mx-auto" data-id="element-60">
          <CTAButton text="→ ASEGURAR MI PRECIO AHORA" href="#compra" isLink={true} data-id="element-61" />
        </div>
      </div>
    </section>;
}